import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = { class: "offcanvas-footer" }

import { reactive, ref } from "vue";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { useUpdateUser } from "@/composables/useAuth";
import { syncSession } from "@/di/useCases";
import { FileBaseUrl } from "@phurshell/psiapp-frontend-core";


export default /*#__PURE__*/_defineComponent({
  __name: 'CRP',
  setup(__props) {

const session = useSessionStore().session;
const submitting = ref(false);

function toDocumentUrl(path: string | null | undefined): string {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${FileBaseUrl}${path}`;
}

const images = reactive<{ [key: string]: { path: string; file: any } }>({
  document_image: { path: toDocumentUrl(session?.document_image), file: null },
  document_in_hand: {
    path: toDocumentUrl(session?.document_in_hand),
    file: null,
  },
});

const currentImagetoUpload = ref("document_image");

const { mutateAsync: updateUser } = useUpdateUser();

function onImageUploaded(event: any, type: string) {
  images[type].path = event.base64;
  images[type].file = event.file;
  currentImagetoUpload.value = type;
}

async function updateDocuments() {
  try {
    submitting.value = true;
    await updateUser({
      id: session!.id,
      document_image: images.document_image.file,
      document_in_hand: images.document_in_hand.file,
    } as any);
    await syncSession.execute();
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Alterações feitas",
      msg: "Suas informações foram salvas",
    });
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_ImageCropper = _resolveComponent("ImageCropper")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ImageCropper, {
        required: "",
        accept: '.jpeg,.png,.jpg',
        aspectRatio: 1 / 1,
        onCropEnd: _cache[0] || (_cache[0] = ($event: any) => (onImageUploaded($event, 'document_image'))),
        class: "mb-4",
        modalId: "document_image",
        inputId: "document_image_input",
        label: "Foto do seu CRP",
        image: images.document_image.path,
        backdrop: "false"
      }, null, 8, ["image"]),
      _createVNode(_component_ImageCropper, {
        required: "",
        accept: '.jpeg,.png,.jpg',
        aspectRatio: 1 / 1,
        onCropEnd: _cache[1] || (_cache[1] = ($event: any) => (onImageUploaded($event, 'document_in_hand'))),
        class: "mb-4",
        modalId: "document_in_hand",
        inputId: "document_image_input",
        label: "Foto sua segurando seu CRP",
        image: images.document_in_hand.path,
        backdrop: "false"
      }, null, 8, ["image"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Button, {
        fullWidth: "",
        label: "Concluir",
        onOnClick: updateDocuments,
        loading: submitting.value,
        marginVertical: false,
        disabled: !currentImagetoUpload.value
      }, null, 8, ["loading", "disabled"])
    ])
  ], 64))
}
}

})